import { call } from 'redux-saga/effects';

import createWorker from 'app/redux/utils/create-worker';
import workInterval from 'app/redux/utils/work-interval';

import constants from 'app/constants/cache';

import responsesAPI from 'app/api/responses';

const execute = function*() {
  return yield call(responsesAPI.getResponses);
};

export const {
  Actions,
  Generators,
  ReducerHandlers,
  Saga,
  Types,
  initState,
  localStateSelector,
  Selectors,
} = createWorker('responses/get-all', {
  localStateSelector: 'responsesGetAll',
  execute,
  shouldWork: workInterval(constants.defaultUpdateIntervalInMilliseconds),
  takePolicy: 'latest',
});



// WEBPACK FOOTER //
// ./src/redux/responses/get-all/workers.js